(function () {
    'use strict';

    angular.module("imApp").factory("skillsCertificateService", ['$ihttp', function ($ihttp) {
        let service = {
            getSkillsCertificate: function (parms) {
                return $ihttp.post({
                    method: 2502,
                    parameters: parms || {}
                });
            },
            listSkillsCertificateTypes: function (parms) {
                return $ihttp.post({
                    method: 2503,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2504,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
